import { defineMessages } from 'react-intl';

export default defineMessages({
  role: 'Role',
  purpose: 'Purpose',
  otherRoles: 'Other roles',
  profile: 'Profile',
  geo: 'Geo',
  'find-analysis': 'Find analysis',
  ratings: 'Ratings',
  grades: 'Ratings',
  nps: 'NPS',
  additional: 'Miscellaneous',
  inactive: 'Inactive',
  csi: 'CSI',
  traffic: 'Analytics',
  npsScore: 'NPS score',
  flaggedComments: 'Flagged comments',
  languages: 'Languages',
  countries: 'Countries',
  webpageUrls: 'Top pages',
  pageflow: 'Page flow',
  date: 'Date',
  text: 'Text',
  comment: 'Comment',
  email: 'E-mail',
  grade: 'Rating',
  responses: 'Responses',
  webpageUrl: 'Page',
  comments: 'Comments',
  filter: 'Filter',
  empty: 'No data available',
  questions: 'Questions',
  funnels: 'Funnels',
  noMatomoLicense: '<p>There’s no data here :( But we can easily fix that for you!</p><p>With analytics you can create segments based on visited URLs (for the users whole session, not just where they answered the survey). This is included in your license. We host the data ourselves (stored at servers in Sweden).</p><p>For the full experience of our analytics, upgrade to a Standard or Deep license. Then you’ll be able to look at survey segments in the analytics data. For example – what does your potential customers’ user journeys look like?</p><p>To turn on Extellio analytics, reach out to your contact person at Extellio or send an email to customersuccess@extellio.com.</p>',
  noMatomoTry: '<p>There’s no data here :(</p><p>But it’s easy to fix.</p><p>If you collect website traffic data with Extellio you can combine survey and analytics data. For example – what does your potential customers’ user journeys look like?</p><p>We host the data ourselves (stored at servers in Sweden) and use Matomo as our platform.</p><p>Try it know! It’s included in your license. Reach out to your contact person at Extellio or send an email to customersuccess@extellio.com.</p>',
  noMatomoData: '<p>There’s no data collected, make sure the script runs on your website.</p>',
  responseLimit: 'Only the first {value} responses are considered due to license restrictions. {license}',
  noLicense: 'You need to get a license to show any results.',
  generalEmpty: 'You don’t have any general surveys. But it’s easy to create one. General surveys are perfect for monitoring your website, making sure you’re on the right track. It’s also a great way to discover problem areas with your website.',
  feedbackEmpty: 'Ohoh! No data here :) But you have the possibility to create a feedback. With a feedback you’ll get users views connected to the page they answer.',
  targetedEmpty: 'Ohoh! There’s no data here. But there could be. Targeted surveys are the perfect way to target a specific audience. Either evaluate a specific process on your website (job application, purchase process, forms) or create a survey triggered on behavior (specific URL’s for example).',
  generalNoLicense: 'To create a general survey you need to upgrade your license. To do that, contact anyone at Extellio!',
  feedbackNoLicense: 'To create a feedback you need to upgrade your license. To do that, contact anyone at Extellio!',
  targetedNoLicense: 'To create a targeted survey you need to upgrade your license. To do that, contact anyone at Extellio!',
  createSurvey: 'Go to your data source to create a survey.',
  createSurveyNoAccess: 'Sorry! Your user level is not authorized to create surveys. If you need this, ask someone in your team to upgrade your user level to Advanced user or contact customersuccess@extellio.com.',
  noHeatmaps: 'Ohoh! No data here :) But you have the possibility to create a heatmap from the data source settings.',
  noSessionRecordings: 'Ohoh! No data here :) But you have the possibility to create a session recording from the data source settings.',
  questionComparisonHeader: 'Compare "{question}" to ',
  selectComparison: 'Please chose a comparison question',
  scatterChart: 'Scatter Chart',
  table: 'View raw data',
  noTagManager: '<p>To access Extellio Tag Manager, reach out to your contact person at Extellio or send an email to customersuccess@extellio.com.</p>',
});
